import '.d{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a6{gap:0.5rem;}.ssr-plugin'
import '.by{font-size:0.875rem;}.ssr-plugin'
import '.bz{color:var(--gray-300);}.ssr-plugin'
import { Avatar, AvatarSize, AvatarShape } from '@app/components/core/avatar/Avatar'
import { styled } from 'inlines'

interface AuthorProps {
  avatarSrc?: string
  avatarSize?: AvatarSize
  avatarShape?: AvatarShape
  name: string
  description?: string
}

export const Author = ({
  avatarSrc,
  avatarSize = 'small',
  avatarShape = 'circle',
  name,
  description,
}: AuthorProps) => {
  return (
    <div className="d f a6"
    >
      <Avatar size={avatarSize} image={avatarSrc} labelSource={name} shape={avatarShape} />

      <div>
        <styled.strong>{name}</styled.strong>
        <div className="by bz"
        >
          {description}
        </div>
      </div>
    </div>
  )
}
